import React from "react";
import styled from "styled-components";
import { StyledButton } from "../../../CommonUI/BuildlingBlocks/StyledButton";

import { UploadIcon } from "../../../CommonUI/Icon/UploadIcon";

import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { StyledFormHelperText } from "./CommonStyled";

import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { IssueData } from "../../Utilities/ControlRenderContext";

import { FileFormControl } from "../FileFormControl";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

class XFileUploadEditUI extends React.Component<{ editMe: FileUploadFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor()}

                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="showFileName"
                    label="Show File Name"
                />
                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="showFileSize"
                    label="Show File Size"
                />
                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="showPreview"
                    label="Show Preview"
                />
                <PropertyEditorInteger
                    editObject={this.props.editMe}
                    propertyName="filesLimit"
                    label="Files Limit"
                />
            </UISpacedBoxContent>
        );
    }
}

export class FileUploadFormControl extends FileFormControl {
    readonly __type: string = "File Upload";

    render() {
        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";

        return (
            <UploadControlRender className="UploadControl-root">
                {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                <StyledButton
                    variant="contained"
                    sx={{ background: UIStyleConstants.BLUE_COLOR }}
                    startIcon={<UploadIcon />}
                    style={{ marginBottom: "30px" }}
                    onClick={this.openLayer}
                    data-testid="btn-xFileUpload-upload"
                    ref={this.ref}
                >
                    Upload
                </StyledButton>
                {this.renderLayerContent()}
                {issueText && (
                    <StyledFormHelperText error={Boolean(issueText)}>{issueText ? issueText : ""}</StyledFormHelperText>
                )}
            </UploadControlRender>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XFileUploadEditUI editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type");
    }
}

const UploadControlRender = styled.div`
    position: relative;
`;
